export const SOCKETIO_CONST = {
    STOCK_SUBS: "MW.IWS.STOCKS.SUBS",
    STOCK_UNSUBS: "MW.IWS.STOCKS.UNSUBS",
    STOCK_SUBS_RSP: "MW.IWS.STOCKS.SUBS.RSP",
    MARKETDATA: "MARKETDATA",
    INDEXMASTER_RSP: "INDEXMASTER.RSP",
    INDEXDETAILS_RSP: "INDEXDETAILS.SUBS.RSP",
    INDEX: "INDEX",
    INDEXDETAILS: "INDEXDETAILS",
    TICKERINTO: "TICKERINTO",
    MKTSTATS: "MKTSTATS",
    MKTPHASE: 'MKTPHASE'
}
export const ModelConstants = {
    BREAKPOINTS: [0.75, 0.9, 1],
    INITBREAKPOINT: 0.75,
    ORDER_ENTRY_CUSTOM_CSS: "order-entry-custom-modal",
    CANCEL_ROLE:"cancel",
    CONFIRM_ROLE: "confirm",
    DISMISS: "Dismiss"
}
export const CONSTANTS = {
    DELIMITER_HASH: "#",
    BUY: "BUY",
    SELL: "SELL",
    ENTRY: "ENTRY",
    MODIFY: "MODIFY",
    CANCEL: "CANCEL",
    POST: 'POST',
    DELIVERY: "DELIVERY",
    UP: "UP",
    DOWN: "DOWN",
    AL: "AL",
    ALL : "ALL",
    DATE_YYYY_MM_DD: "yyyy-MM-dd",
    PRINT_WRAPPER: "print-wrapper",
    EMPTY_STRING: "",
    LANG_EN: "en",
    LANG_BN: "bn",
    LOGGED_IN: "LoggedIn",
    NORMAL:"NORMAL",
    NR: "NR",
    SPOT:"SPOT",
    SP:"SP",
    CANCEL_TEXT:"Cancel",
    COMBINED_CHART:"combinedchart",
    INDEX_CHART:"indexchart",
    LINE_CHART:"linechart",
    ANNOUNCEMENT_ROUTING_TYPE:5,
    ANNOUNCEMENT_DEFAULT_TIME:"000000",
    ANNOUNCEMENT_SELECTED_STOCK:"ALL",
    ANNOUNCEMENT_PRIORITY:0,
    SESSION_EXPIRED: "Invalid Session or Session Expired..!",
    GET: "GET",
    DELETE: "DELETE",
    PUT: "PUT",
    BASE_URL: "baseURL",
    INDEX_RSP_RECV: "IndexResponseReceived",
    Normal: "Normal",
    MKT_PHASE_TOPIC: "mktPhase",
    OBJECT: "object",
    EQUITY: "EQUITY",
    DEBT: "DEBT",
    HYPHEN: "-",
    SLASH: "/",
    FORCE_CHANGE_PWD: "forcechangepassword",
    LIMIT: "LIMIT",
    GTD: "GTD",
    MFL: "MFL",
    MARKET: "MARKET",
    STOPMARKET: "STOPMARKET",
    STPMKT: "STPMKT",
    STPLMT: "STPLMT",
    STOPLIMIT: "STOPLIMIT",
    POSITIONS : "Positions",
    STOCKLIMIT: "30",
    WATCHLISTLIMIT: "10"
}
export const FieldNameConst = {
    COMPANY_NAME: "companyName",
    EXCH: "exch",
    EXCHANGE: "exchange",
    ROW_SELECTED: "rowSelected",
    MODE_SELECTED: "modeSelected",
    OPERATION_TYPE: "operationType",
    IDX: "idx",
    RESP_CODE: "respCode",
    RESPONSE: "response",
    ERR_MSG: "errMsg",
    ORD_FILL_AVG: "ordFillAvg",
    DEFAULT: "default",
    BIDASK:"bidask",
    OHLC:"ohlc",
    TURNTRADEVOLUME: "turnTradeVolume",
    EXCH_SYMBOL: "ExchSymbol",
    SYMBOL: "Symbol",
    INDEXID: "indexId",
    FROMDATE: "fromDate",
    TODATE: "toDate",
    ENDTIME: "endTime",
    symbol: "symbol",
    ROUTINGTYPE: "routingType",
    CLIENTID: "clientid",
    TRADING_CODE: "tradingcode",
    MAGINGROUP: "margingroup",
    clientId: "clientId",
    BUYPOWER: "buyPower",
    BUYINGPOWER: "buyingPower",
    AVAQTY: "avaQty",
    STOCK_LIST: "exchangewiseStockList",
    BODY: "body",
    DATA_THEME: "data-theme",
    PRODUCT: "product",
    TARGET: "target",
    REPORTTYPE: "reportType",
    BOARD: "board",
    SEGMENT: "segment",
    STATUS: "status",
    VERB: "verb",
    DISCLOSEDQTY: "disclosedQty",
    EXPIRYDATE: "expiryDate",
    FILLTYPE: "fillType",
    MINFILlQTY: "minFillQty",
    PRICE: "price",
    PRICEVIOLATION: "priceViolation",
    ORDERTYPE: "orderType",
    PROTECTIONPERCENT: "protectionPercent",
    QUANTITY: "quantity",
    REFERENCEID: "referenceId",
    TRIGGERPRICE: "triggerPrice",
    DISPLAYEXCH: "displayExch",
    ORDER: "order",
    TITLE: "title",
    LASTMODIFIEDDATE: "lastModifiedDate",
    LASTMODIFIEDTIME: "lastModifiedTime",
    ORDERREFNUMBER: "orderRefNumber",
    COMMISSION : "commission",
    REASON : "reason",
    PASSKEY : "passkey",
    PENDINGQTY : "pendingQty",
    EXCHREFNO : "exchrefno",
    ORDERREFNO : "orderrefno",
    SORTINGFILED :'sortingFiled',
    SORTREVERSE : 'sortReverse',
    NETCHANGE : 'Netchange'
}
export const RountingPath = {
    LOGIN: "/login",
    ORDER_HISTORY: "/order-history",
    TABS_HOME:"/tabs/home",
    TABS: "./UI/footer-tabs/tabs/tabs.module",
    TAB : "/tabs"
}
export const ASSET_PATH = {
    PRODUCTCONFIG_MAP:"./assets/json/productconfigmap.json",
    REQUESTURL_MAP:"./assets/json/requesturlmapping.json",
    SORTINGCONFIG_MAP: "./assets/json/sortingConfigMap.json",
    ENVIRONMENT: "./assets/config/environments.json",
    MESSAGE_MAP: "./assets/json/messagemap.json",
    I18N: "./assets/i18n/",
}
export const KeyConstants = {
    LOGONQ: "LOGONQ",
    LOGONP: "LOGONP",
    AUTHQ: "AUTHQ",
    AUTHP: "AUTHP",
    ORDERBOOKQ: "ORDERBOOKQ",
    ORDERBOOKP: "ORDERBOOKP",
    ORDERHISTORYQ: "ORDERHISTORYQ",
    ORDERHISTORYP: "ORDERHISTORYP",
    ORDERENTRYQ: "ORDERENTRYQ",
    ORDERENTRYP: "ORDERENTRYP",
    POSTAUTHQ: "POSTAUTHQ",
    BOARD: "BOARD",
    ORDERSTATUS: "ORDERSTATUS",
    EXCHANGE: "EXCHANGE",
    THEME_SERVICE: "THEME_SERVICE",
    DISPLAYEXCHANGE: "DISPLAYEXCHANGE",
    READONLY_WLIST: "READONLY_WLIST",
    USERCTX: "USERCONTEXT",
    NODEMASTER: "NODEMASTER",
    WATCHMASTER: "WATCHMAST",
    MASTERSTOCKMAP: "MASTERSTOCKMAP",
    PORTFOLIOWATCHLIST: "PORTFOLIOWATCHLIST",
    MASTERDOWNLOAD: "MASTERDOWNLOAD",
    DEFAULTMASTERS: "DEFAULTMASTERS",
    NEWSLIST: "NEWSLIST",
    NODELIST: "NODELIST",
    NOTIFICATION: "NOTIFICATION",
    ORDERCANCELQ: "ORDERCANCELQ",
    ORDERMODIFYQ: "ORDERMODIFYQ",
    LOGOUTQ: "LOGOUTQ",
    LOGOUTP: "LOGOUTP",
    TRADEBOOKQ: "TRADEBOOKQ",
    TRADEBOOKP: "TRADEBOOKP",
    TRADEPOSQ: "TRADEPOSQ",
    TRADEPOSP: "TRADEPOSP",
    ORDER_BOOK_EXPORT_XL: "ORDER_BOOK_EXPORT_XL",
    TRADE_BOOK_EXPORT_XL: "TRADE_BOOK_EXPORT_XL",
    POSITION_EXPORT_XL: "POSITION_EXPORT_XL",
    HOLDINGS_EXPORT_XL: "HOLDINGS_EXPORT_XL",
    MARKETSTATISTICSQ: "MARKETSTATISTICSQ",
    MARKETSTATISTICSP: "MARKETSTATISTICSP",
    MARGINSUMQ: "MARGINSUMQ",
    MARGINSUMP: "MARGINSUMP",
    NEWSQ: "NEWSQ",
    NEWSP: "NEWSP",
    PORTFOLIOQ: "PORTFOLIOQ",
    PORTFOLIOP: "PORTFOLIOP",
    PORTFOLIO_WATCHP: "PORTFOLIO_WATCHP",
    CHARTQ: "CHARTQ",
    GENPASS:"GENPASS",
    CHANGEPASS:"CHANGEPASS",
    PAGESLIST: "PAGES_LIST",
    LANGUAGE: "LANGUAGE",
    USR_PREFERENCE: "USR_PREFERENCE",
    INSTDETAILSQ: "INSTDETAILSQ",
    INSTDETAILSP: "INSTDETAILSP",
    STOCKQUOTEQ: "STOCKQUOTEQ",
    STOCKQUOTEP: "STOCKQUOTEP",
    BUYING_POWER_SUMQ: "BUYING_POWER_SUMQ",
    MTASQ: "MTASQ",
    MTASP: "MTASP",
    CHART_SERIES_TYPES:"CHART_SERIES_TYPES",
    CHART_INDICATOR_TYPES:"CHART_INDICATOR_TYPES",
    CHART_ANNOTATION_TYPES:"CHART_ANNOTATION_TYPES",
    CHART_STROKE_TYPES:"CHART_STROKE_TYPES",
    CHART_STROKE_SIZE :"CHART_STROKE_SIZE"
}

export const RequestURL = {
    LOGONQ_API: "LOGONQ_API",
    ORDERBOOKQ_API: "ORDERBOOKQ_API",
    ORDERHISTORYQ_API: "ORDERHISTORYQ_API",
    ORDERENTRYQ_API: "ORDERENTRYQ_API",
    SESSIONDATA_API: "SESSIONDATA_API",
    DEFAULT_MASTER_API: "DEFAULT_MASTER_API",
    MASTER_DOWNLOAD_API: "MASTER_DOWNLOAD_API",
    STOCK_DOWNLOAD_API: "STOCK_DOWNLOAD_API",
    STOCK_STMT_API: "STOCK_STMT_API",
    NODE_DETAILS_API: "NODE_DETAILS_API",
    AUTHENTICATE_API: "AUTHENTICATE_API",
    ORDERCANCELQ_API: "ORDERCANCELQ_API",
    ORDERMODIFYQ_API: "ORDERMODIFYQ_API",
    LOGOUTQ_API: "LOGOUTQ_API",
    TRADEBOOKQ_API: "TRADEBOOKQ_API",
    TRADEPOSQ_API: "TRADEPOSQ_API",
    MARKETSTATISTICS_API: "MARKETSTATISTICS_API",
    MARGIN_STMTQ_API: "MARGIN_STMTQ_API",
    NEWS_API: "NEWS_API",
    SECTOR_WATCH_API: "SECTOR_WATCH_API",
    PORTFOLIOQ_API: "PORTFOLIOQ_API",
    CHARTQ_API: "CHARTQ_API",
    GENPASS_API: "GENPASS_API",
    CHANGEPASS_API:"CHANGEPASS_API",
    INSTRUMENTDETAILS_API: "INSTRUMENTDETAILS_API",
    STOCKQUOTE_API: "STOCKQUOTE_API",
    SAVE_USR_PREF: "SAVE_USR_PREF",
    BUYING_POWER_SUM_API: "BUYING_POWER_SUM_API",
    MTAS_API: "MTAS_API"
}

export const SortingList = {
    "ORDERBOOK_SORT": "ORDERBOOK_SORT",
    "TRADEBOOK_SORT": "TRADEBOOK_SORT",
    "POSITION_SORT": "POSITION_SORT",
    "MARKETWATCH_SORT": "MARKETWATCH_SORT"
}
export const MsgBoxIcons = {
    Information: 'information-circle-outline',
    Warning: 'warning-outline'
}
